import { render, staticRenderFns } from "./ApplicantDetailSelection.vue?vue&type=template&id=5888448f"
import script from "./ApplicantDetailSelection.vue?vue&type=script&lang=js"
export * from "./ApplicantDetailSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports